import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const state = {
  code: '110000',
  name: '北京',
};
const mutations = {
  //方法
};

export default new Vuex.Store({
  state,
  mutations
})
